import { render, staticRenderFns } from "./ConsultaReclamaciones.vue?vue&type=template&id=4c247c5a&scoped=true"
import script from "./ConsultaReclamaciones.vue?vue&type=script&lang=ts"
export * from "./ConsultaReclamaciones.vue?vue&type=script&lang=ts"
import style0 from "./ConsultaReclamaciones.vue?vue&type=style&index=0&id=4c247c5a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c247c5a",
  null
  
)

export default component.exports